import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchBanner = createAsyncThunk(
    'banner/fetchBanner',
    async (limit = null, { rejectWithValue }) => {
        try {
            const params = {}
            if (limit != null) {
                params.limit = limit
            }
            const response = await callAPIWithoutAuth(
                apiUrls.bannerListing,
                params,
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch categories');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const bannerSlice = createSlice({
    name: 'banner',
    initialState: {
        banners: [],
        data: [],
        loading: false,
        error: null
    },
    reducers: {
        clearBannersError: (state) => {
            state.error = null;
        },
        clearBanners: (state) => {
            state.banners = [];
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBanner.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBanner.fulfilled, (state, action) => {
                state.loading = false;
                state.banners = action.payload;
                state.data = action.payload.data || action.payload;
            })
            .addCase(fetchBanner.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearBannersError, clearBanners } = bannerSlice.actions;
export default bannerSlice.reducer;